import React from 'react';
import { Alert } from 'reactstrap';
import ReportsListRow from './ReportsListRow';

const ReportListTable = ({ reports, onBoxClick }) => {
  return (
    <div className="table-header-fixed">
      <table className="provisionList">
        <thead>
          <tr>
            <th className="cursor-pointer">Reports</th>
            <th>Owner</th>
            <th className="cursor-pointer">Sharing Status</th>
          </tr>
        </thead>
        <tbody>
          {reports.length ? (
            reports.map((report, i) => (
              <ReportsListRow report={report} key={i} onBoxClick={onBoxClick} />
            ))
          ) : (
            <tr>
              <td colSpan={10}>
                <Alert rowSpan={10} color="info">
                  No Reports for found.
                </Alert>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ReportListTable;
